import { splitIsolates } from '@pa/core';

/**
 * Bidi isolation for the web (M5.1). `<Bdi>` renders one left-to-right fragment (a time range,
 * a date, an email address, a timezone, a code) isolated inside Arabic text; `<Isolated>` takes
 * a whole line and wraps every such fragment it finds, so «14:00–15:00» never renders as
 * 15:00–14:00 and an address never breaks around the @.
 */
export function Bdi({ children, className }: { children: React.ReactNode; className?: string }) {
  return (
    <bdi dir="ltr" className={['[unicode-bidi:isolate]', className ?? ''].join(' ').trim()}>
      {children}
    </bdi>
  );
}

export function Isolated({ text }: { text: string }) {
  const parts = splitIsolates(text);
  if (parts.length === 1 && !parts[0]?.ltr) return <>{parts[0]?.text ?? ''}</>;
  return (
    <>
      {parts.map((p, i) =>
        p.ltr ? <Bdi key={`${i}:${p.text}`}>{p.text}</Bdi> : <span key={`${i}:t`}>{p.text}</span>,
      )}
    </>
  );
}
